(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


"use strict";
var $0158782d112d75f2$exports = {};


"use strict";
var $0158782d112d75f2$var$Tile = /*#__PURE__*/ function() {
    function Tile(position, value) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Tile);
        this.x = position.x;
        this.y = position.y;
        this.value = value || 2;
        this.previousPosition = null;
        this.mergedFrom = null;
        this.id = Tile.idCounter++;
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Tile, [
        {
            key: "savePosition",
            value: function savePosition() {
                this.previousPosition = {
                    x: this.x,
                    y: this.y
                };
            }
        },
        {
            key: "updatePosition",
            value: function updatePosition(position) {
                this.x = position.x;
                this.y = position.y;
            }
        },
        {
            key: "serialize",
            value: function serialize() {
                return {
                    position: {
                        x: this.x,
                        y: this.y
                    },
                    value: this.value,
                    mergedFrom: this.mergedFrom ? this.mergedFrom.map(function(t) {
                        return t.serialize();
                    }) : null,
                    id: this.id
                };
            }
        }
    ]);
    return Tile;
}();
$0158782d112d75f2$var$Tile.idCounter = 0;
$0158782d112d75f2$exports = $0158782d112d75f2$var$Tile;


var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        var _this = this;
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.size = 4;
        this.score = 0;
        this.status = "idle";
        this.board = Array(this.size).fill(null).map(function() {
            return Array(_this.size).fill(null);
        });
        if (initialState) {
            this.score = initialState.score;
            this.status = initialState.status;
            initialState.board.forEach(function(row, y) {
                row.forEach(function(value, x) {
                    if (value !== 0) _this.board[y][x] = new $0158782d112d75f2$exports({
                        x: x,
                        y: y
                    }, value);
                });
            });
        } else {
            this.addRandomTile();
            this.addRandomTile();
        }
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "prepareTiles",
            value: function prepareTiles() {
                this.board.flat().forEach(function(tile) {
                    if (tile) {
                        tile.mergedFrom = null;
                        tile.savePosition();
                    }
                });
            }
        },
        {
            key: "syncTilePositions",
            value: function syncTilePositions() {
                this.board.forEach(function(row, y) {
                    row.forEach(function(tile, x) {
                        if (tile) tile.updatePosition({
                            x: x,
                            y: y
                        });
                    });
                });
            }
        },
        {
            key: "shiftLeft",
            value: function shiftLeft() {
                var _this = this, _loop = function(y) {
                    var row = _this.board[y].filter(function(tile) {
                        return tile !== null;
                    });
                    for(var i = 0; i < row.length - 1; i++){
                        if (row[i] === null) continue;
                        if (row[i].value === row[i + 1].value) {
                            var tile1 = row[i];
                            var tile2 = row[i + 1];
                            var val = tile1.value * 2;
                            _this.score += val;
                            if (val === 2048) _this.status = "won";
                            var merged = new $0158782d112d75f2$exports({
                                x: -1,
                                y: -1
                            }, val);
                            merged.mergedFrom = [
                                tile1,
                                tile2
                            ];
                            row[i] = merged;
                            row[i + 1] = null;
                        }
                    }
                    row = row.filter(function(tile) {
                        return tile !== null;
                    });
                    while(row.length < _this.size)row.push(null);
                    if (_this.arraysEqual(_this.board[y], row) === false) {
                        moved = true;
                        _this.board[y] = row;
                    }
                };
                var moved = false;
                for(var y = 0; y < this.size; y++)_loop(y);
                return moved;
            }
        },
        {
            key: "afterMove",
            value: function afterMove() {
                this.syncTilePositions();
                this.addRandomTile();
                if (this.canMove() === false) this.status = "lost";
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                this.prepareTiles();
                var moved = this.shiftLeft();
                if (moved) this.afterMove();
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                this.prepareTiles();
                this.reverseRows();
                var moved = this.shiftLeft();
                this.reverseRows();
                if (moved) this.afterMove();
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                this.prepareTiles();
                this.transpose();
                var moved = this.shiftLeft();
                this.transpose();
                if (moved) this.afterMove();
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                this.prepareTiles();
                this.transpose();
                this.reverseRows();
                var moved = this.shiftLeft();
                this.reverseRows();
                this.transpose();
                if (moved) this.afterMove();
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return {
                    board: this.board.map(function(row) {
                        return row.map(function(tile) {
                            return tile ? tile.value : 0;
                        });
                    }),
                    score: this.score,
                    status: this.status,
                    tiles: this.board.flat().filter(function(tile) {
                        return tile !== null;
                    }).map(function(tile) {
                        return tile.serialize();
                    })
                };
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                this.restart();
            }
        },
        {
            key: "restart",
            value: function restart() {
                var _this = this;
                this.board = Array(this.size).fill(null).map(function() {
                    return Array(_this.size).fill(null);
                });
                this.score = 0;
                this.status = "playing";
                this.addRandomTile();
                this.addRandomTile();
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                var emptyCells = [];
                for(var y = 0; y < this.size; y++){
                    for(var x = 0; x < this.size; x++)if (this.board[y][x] === null) emptyCells.push({
                        x: x,
                        y: y
                    });
                }
                if (emptyCells.length === 0) return;
                var _emptyCells_Math_floor = emptyCells[Math.floor(Math.random() * emptyCells.length)], randX = _emptyCells_Math_floor.x, randY = _emptyCells_Math_floor.y;
                this.board[randY][randX] = new $0158782d112d75f2$exports({
                    x: randX,
                    y: randY
                }, Math.random() < 0.1 ? 4 : 2);
            }
        },
        {
            key: "arraysEqual",
            value: function arraysEqual(a, b) {
                return a.length === b.length && a.every(function(val, index) {
                    return val === b[index];
                });
            }
        },
        {
            key: "canMove",
            value: function canMove() {
                for(var y = 0; y < this.size; y++)for(var x = 0; x < this.size; x++){
                    var val = this.board[y][x];
                    if (val === null) return true;
                    if (x < this.size - 1) {
                        var right = this.board[y][x + 1];
                        if (right && val.value === right.value) return true;
                    }
                    if (y < this.size - 1) {
                        var down = this.board[y + 1][x];
                        if (down && val.value === down.value) return true;
                    }
                }
                return false;
            }
        },
        {
            key: "reverseRows",
            value: function reverseRows() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.board[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var row = _step.value;
                        row.reverse();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "transpose",
            value: function transpose() {
                var _this = this;
                var newBoard = Array(this.size).fill(null).map(function() {
                    return Array(_this.size).fill(null);
                });
                for(var y = 0; y < this.size; y++)for(var x = 0; x < this.size; x++)newBoard[x][y] = this.board[y][x];
                this.board = newBoard;
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$startButton = document.querySelector(".button.start");
var $197cd56b15c33885$var$scoreElement = document.querySelector(".game-score");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$tileContainer = document.querySelector(".tile-container");
var $197cd56b15c33885$var$tilesMap = new Map();
function $197cd56b15c33885$var$getTilePosition(x, y) {
    return {
        top: "".concat(10 + y * 110, "px"),
        left: "".concat(10 + x * 110, "px")
    };
}
function $197cd56b15c33885$var$createTileElement(tile) {
    var el = document.createElement("div");
    el.classList.add("tile");
    el.classList.add("tile--".concat(tile.value));
    el.textContent = tile.value;
    var pos = $197cd56b15c33885$var$getTilePosition(tile.position.x, tile.position.y);
    el.style.top = pos.top;
    el.style.left = pos.left;
    return el;
}
function $197cd56b15c33885$var$renderBoard(state) {
    $197cd56b15c33885$var$scoreElement.textContent = state.score;
    $197cd56b15c33885$var$messageStart.classList.add("hidden");
    if (state.status === "won") $197cd56b15c33885$var$messageWin.classList.remove("hidden");
    if (state.status === "lost") $197cd56b15c33885$var$messageLose.classList.remove("hidden");
    var activeIds = new Set();
    state.tiles.forEach(function(tile) {
        activeIds.add(tile.id);
        if (tile.mergedFrom) tile.mergedFrom.forEach(function(parent) {
            if ($197cd56b15c33885$var$tilesMap.has(parent.id)) {
                var parentEl = $197cd56b15c33885$var$tilesMap.get(parent.id);
                $197cd56b15c33885$var$tilesMap.delete(parent.id);
                var pos = $197cd56b15c33885$var$getTilePosition(tile.position.x, tile.position.y);
                parentEl.style.top = pos.top;
                parentEl.style.left = pos.left;
                parentEl.style.zIndex = "10";
                setTimeout(function() {
                    parentEl.remove();
                }, 200);
            }
        });
        var el = $197cd56b15c33885$var$tilesMap.get(tile.id);
        var pos = $197cd56b15c33885$var$getTilePosition(tile.position.x, tile.position.y);
        if (!el) {
            el = $197cd56b15c33885$var$createTileElement(tile);
            $197cd56b15c33885$var$tileContainer.appendChild(el);
            $197cd56b15c33885$var$tilesMap.set(tile.id, el);
            if (tile.mergedFrom) el.classList.add("tile-merged");
            else el.classList.add("tile-new");
        } else {
            el.style.top = pos.top;
            el.style.left = pos.left;
            if (el.textContent !== tile.value) {
                el.textContent = tile.value;
                el.className = "tile tile--".concat(tile.value);
                el.classList.add("tile-merged");
            }
        }
    });
    var idsToRemove = [];
    $197cd56b15c33885$var$tilesMap.forEach(function(_, id) {
        if (!activeIds.has(id)) idsToRemove.push(id);
    });
    idsToRemove.forEach(function(id) {
        $197cd56b15c33885$var$tilesMap.get(id).remove();
        $197cd56b15c33885$var$tilesMap.delete(id);
    });
}
$197cd56b15c33885$var$startButton.addEventListener("click", function() {
    $197cd56b15c33885$var$messageLose.classList.add("hidden");
    $197cd56b15c33885$var$messageWin.classList.add("hidden");
    $197cd56b15c33885$var$tileContainer.innerHTML = "";
    $197cd56b15c33885$var$tilesMap.clear();
    $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$startButton.textContent = "Restart";
    $197cd56b15c33885$var$startButton.classList.remove("start");
    $197cd56b15c33885$var$startButton.classList.add("restart");
    $197cd56b15c33885$var$renderBoard($197cd56b15c33885$var$game.getState());
});
document.addEventListener("keydown", function(e) {
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
    switch(e.key){
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
        default:
            return;
    }
    $197cd56b15c33885$var$renderBoard($197cd56b15c33885$var$game.getState());
});

})();
//# sourceMappingURL=index.1119361f.js.map
